export default __webpack_public_path__ + "static/media/img-9090.2e1f4a5d.png";